import React from "react";
import Footer from "../wrappers/Footer";
import SecondHeader from "../wrappers/SecondHeader";

const SecondLayout = ({ children }) => {
  return (
    <div className="page-wrapper">
      <SecondHeader />
      {children}
      <Footer />
    </div>
  );
};

export default SecondLayout;
